<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="isPartner ? ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.eigenVermogen?.at(2)?.waardeSlot ?? null) === null : ((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.eigenVermogen?.at(2)?.waardeSlot ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="xl" title="Specificatie herinvesteringsreserve">
  <snelstart-ui-dialog-header-content>
      Vul eerst de dotatie in de kolom rechts in, en klik daarna op '+ Specificatie toevoegen' om de waardes per einde van het boekjaar te specificeren.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
    <div style="display: flex; gap: 1rem; align-items: flex-start;">
      <div class="dialog-left" style="flex: 3 1 0; min-width: 0;">
        <form (change)="saveForm()" [formGroup]="specificatieFg">
          <div formArrayName="specHerinvesteringsreserve">
            @for (item of specificatie.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                <div class="row mb-1" style="--bs-gutter-x: 0.5rem;">
                  <div class="col-auto">
                    <snelstart-ui-text-form-control [label]="i === 0 ? 'Bedrijsmiddel' : ''"
                                                    class="custom-input-200"
                                                    formControlName="omschrijving"
                                                    id="omschrijving-' + i"
                    >
                    </snelstart-ui-text-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-select-form-control [label]="i === 0 ? 'Vervreemding' : ''"
                                                      [options]="jaren"
                                                      class="custom-input-100"
                                                      formControlName="jaarVanVervreemding"
                                                      id="jaarVanVervreemding-' + i"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-number-form-control [label]="i === 0 ? 'Boekwinst' : ''"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="boekwinst"
                                                      id="boekwinst-' + i"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-number-form-control [label]="i === 0 ? 'Afschrijving' : ''"
                                                      [showAllDecimals]="true"
                                                      align="right"
                                                      class="custom-input-100"
                                                      formControlName="afschrijvingspercentage"
                                                      placeholder="20,00%"
                                                      id="afschrijvingspercentage-' + i"
                                                      prefix="%"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-number-form-control [label]="i === 0 ? 'Boekwaarde' : ''"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="boekwaardeOpVervreemdingsmoment"
                                                      id="boekwaardeOpVervreemdingsmoment-' + i"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-auto">
                    <snelstart-ui-button
                      (click)="verwijderRij(i)"
                      [class]="i === 0 ? 'firstrowbutton' : ''"
                      icon="trash"
                      iconType="light"
                      id="buttonDelete-' + i"
                      size="medium"
                      type="secondary"
                    >
                    </snelstart-ui-button>
                  </div>
                </div>
              </div>
            }
          </div>
        </form>
        <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="cancel"
                             type="link">Specificatie toevoegen
        </snelstart-ui-button>
      </div>
      <div class="dialog-right" style="flex: 1 1 0; min-width: 0;">
        <form (change)="saveForm()" [formGroup]="formGroup">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="waardeOpening"
                                            id="waardeOpening-' + i"
                                            label="Openingsbalans"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="dotatieHIR"
                                            id="dotatieHIR-' + i"
                                            label="Dotaties"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control [calculate]="totaalVrijval"
                                            [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="vrijvalHIR"
                                            id="vrijvalHIR-' + i"
                                            label="Berekende vrijval"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="waardeSlot"
                                            id="waardeSlot-' + i"
                                            label="Slotbalans"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </form>
      </div>
    </div>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex mt-2">
    <snelstart-ui-button btn-x class="me-2" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button [disabled]=specificatieFg.invalid icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
